/**
 * Defines a tooltip view.
 *
 */
import Backbone from 'backbone';

import jQuery from 'jquery';

var Events = {
    ON_TOOLTIP_OPENED: 'ON_TOOLTIP_OPENED'
};

const isMobileView = () => {
    return jQuery('body').hasClass('mobile');
};

// This only needs to be done once.
if (!isMobileView()) {
    jQuery(document.body).click(function(e) {
        var event = e || window.event,
            target = jQuery(event.target);

        if (!target.is('.tooltip-active'))
            jQuery('.tooltip-active')
                .tooltip('hide')
                .removeClass('tooltip-active');
    });
}

var ToolTipView = Backbone.View.extend({
    events: {
        click: 'onElementClicked',
        mouseenter: 'onElementMouseEnter',
        mouseleave: 'onElementMouseLeave'
    },

    /**
     *
     * @param args
     *          content: The content to display within the tooltip. Can be html
     *          placement: Optional. Can specify 'bottom' to have the placement to the bottom of the trigger
     */
    initialize: function(args) {
        this.content = args.content || this.$el.attr('title'); // The content to display.
        this.placement = args.placement || this.$el.data('placement'); // Allows the orientation of the tooltip to be optionally specified
        this.container = args.container ? args.container : '.main-body';

        this.allowHtml = 'allowHtml' in args ? args.allowHtml : true;
        this.allowClickThrough = 'allowClickThrough' in args ? args.allowClickThrough : false;
        if (isMobileView()) {
            this.allowClickThrough = true; // mobile has no hover, force allowClickThrough so user can click to show tooltip
        }

        this.isSetup = false;
        this.isHovering = false;

        this.render();
    },

    onElementClicked: function(e) {
        if (!this.allowClickThrough) {
            e.preventDefault();
        }

        this.show();
    },

    onElementMouseEnter: function(e) {
        this.isHovering = true;
        this.show();
    },

    onElementMouseLeave: function() {
        this.isHovering = false;
        this.hide();
    },

    show: function() {
        if (!this.content) {
            return;
        }

        if (!this.isSetup) {
            this.$el.tooltip({
                trigger: 'manual',
                container: this.container
            });
            this.isSetup = true;
        }

        if (this.isHovering) {
            this.$el.tooltip('show');
        }

        if (!this.$el.hasClass('tooltip-active')) {
            this.$el.addClass('tooltip-active');
            this.trigger(Events.ON_TOOLTIP_OPENED);
        }

        // This is a hack to fix an issue with bootstrap events propagating from the tooltip to the modal
        this.$el.on('hidden.bs.modal', function(e) {
            e.stopPropagation();
        });

        this.$el.on('hide.bs.modal', function(e) {
            e.stopPropagation();
        });

        this.$el.on('hide', function(e) {
            e.stopPropagation();
        });
    },

    hide: function() {
        if (this.isSetup) {
            this.$el.tooltip('hide');
        }
        this.$el.removeClass('tooltip-active');
    },

    render: function() {
        this.$el.attr('data-rel', 'tooltip');
        this.$el.attr('data-html', this.allowHtml);
        this.$el.attr('data-original-title', this.content);
        this.$el.attr('aria-label', this.content);

        if (this.placement) {
            this.$el.attr('data-placement', this.placement);
        }
    },

    /**
     * Set content when it needs to change dynamically
     * @param content
     */
    setContent: function(content) {
        this.content = content;
    },

    /**
     * intended for when content is updated and needs to be rendered
     */
    renderContent: function() {
        this.$el.attr('data-original-title', this.content);
        if (this.isHovering) {
            this.onElementMouseEnter();
        }
    }
});

ToolTipView.Events = Events;
ToolTipView.hideAll = function() {
    jQuery('.tooltip-active')
        .tooltip('hide')
        .removeClass('tooltip-active');
};

export default ToolTipView;
